<div data-cid="confirmation-modal" class="relative">
  <div tabIndex="0" class="sr-only" aria-hidden="true"></div>

  <div class="space-y-5">
    <div
      class="prose prose-sm max-w-none sm:prose-base"
      [innerHTML]="content() | safeTransform: 'HTML'"
    ></div>

    <div class="mx-auto w-full max-w-72">
      <ui-button
        fluid
        size="lg"
        rounded="full"
        [isLoading]="confirming()"
        (buttonClick)="handleCloseModal()"
      >
        {{ cta().name }}
      </ui-button>
    </div>
  </div>
</div>
